<template>
  <div class="flex justify-between items-center mb-8">
    <div class="flex-1 max-w-sm"></div>

    <div class="flex-1 max-w-sm">
      <InputText
        v-model="mainForm.eksperthinnangu_nr"
        name="eksperthinnangu_nr"
        placeholder="Nr"
        fluid
        @update:model-value="evaluationStore.save({ assessment_data: { eksperthinnangu_nr: $event } })"
      />
    </div>
    <div class="flex-1 max-w-sm">
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2">
          <label for="detail-author" class="w-1/3 text-right text-sm">
            {{ $t(`messages.detail.author`) }}
          </label>
          <div class="w-2/3">
            <InputText id="detail-author" disabled :value="author?.name" class="w-full" size="small" />
          </div>
        </div>
        <div class="flex items-center gap-2">
          <label for="detail-approver" class="w-1/3 text-right text-sm">
            {{ $t(`messages.detail.authorApprover`) }}
          </label>
          <div class="w-2/3">
            <Select
              id="detail-approver"
              v-model="evaluationApproverId"
              :options="evaluationApprover"
              optionLabel="text"
              optionValue="value"
              placeholder="-"
              class="w-full"
              size="small"
              @update:modelValue="saveEvaluationApprover"
            />
          </div>
        </div>
        <DetailToolbarComponent :statuses="statuses" v-model:selected-status="evaluationStore.status" @update:selected-status="updateSelectedStatus" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3'
import { storeToRefs } from 'pinia'
import { computed, onMounted, shallowRef } from 'vue'
import { useDetailStore } from '@/stores/useDetailStore'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import DetailToolbarComponent from './DetailToolbarComponent.vue'

defineProps({
  evaluationApprover: {
    type: Array,
    default: () => [],
  },
})

const page = usePage()
const detailStore = useDetailStore()
const evaluationStore = useEvaluationStore()

const author = computed(() => page.props.author)

const { evaluationApproverId, mainForm } = storeToRefs(detailStore)

const statuses = shallowRef([
  {
    name: 'Kinnitatud',
    value: 'finalized',
  },
  {
    name: 'Hindamisel',
    value: 'in_progress',
  },
])

const updateSelectedStatus = e => {
  evaluationStore.save({ status: e })
}

const saveEvaluationApprover = value => {
  evaluationStore.save({
    evaluationApproverId: value,
  })
}
</script>
